import './App.scss';

import Layout from './layout/Layout';
import React from 'react';

function App() {
  return (
    <div className="App">
      <Layout />
    </div>
  );
}

export default App;
